import type { Platform } from '@/hooks/useCalculator';

interface PlatformsBlockProps {
  platforms: Platform[];
  onToggle: (id: string) => void;
  onProfilesChange: (id: string, value: number) => void;
  enabledCount: number;
}

const DISCOUNT_LABELS: Record<number, string> = {
  2: '10',
  3: '15',
  4: '20',
};

export default function PlatformsBlock({
  platforms,
  onToggle,
  onProfilesChange,
  enabledCount,
}: PlatformsBlockProps) {
  const showDiscount = enabledCount >= 2;
  const discountPercent = DISCOUNT_LABELS[Math.min(enabledCount, 4)];

  return (
    <section className="py-8 border-b border-gray-200">
      <h2 className="text-base font-semibold text-gray-900 mb-5">Выбери площадки, которые планируешь использовать</h2>

      <div className="space-y-3">
        {platforms.map(platform => (
          <div
            key={platform.id}
            className="flex items-center gap-4 py-3 border border-gray-100 rounded-lg px-4"
          >
            <input
              type="checkbox"
              id={`platform-${platform.id}`}
              checked={platform.enabled}
              onChange={() => onToggle(platform.id)}
              className="w-4 h-4 accent-[#2563EB] cursor-pointer flex-shrink-0"
            />
            <label
              htmlFor={`platform-${platform.id}`}
              className="flex-1 text-sm font-medium text-gray-800 cursor-pointer whitespace-nowrap"
            >
              {platform.name}
            </label>
            <span className="text-sm text-gray-400 whitespace-nowrap">
              ${platform.basePrice}/мес
            </span>
            <div className="flex items-center gap-2 ml-2">
              <label
                htmlFor={`profiles-${platform.id}`}
                className="text-xs text-gray-400 whitespace-nowrap"
              >
                Кол-во профилей
              </label>
              <input
                id={`profiles-${platform.id}`}
                type="number"
                min={1}
                max={10}
                value={platform.profiles}
                disabled={!platform.enabled}
                onChange={e => onProfilesChange(platform.id, parseInt(e.target.value, 10) || 1)}
                className="w-16 text-sm text-center border border-gray-200 rounded-md py-1 px-2 text-gray-900 disabled:bg-gray-50 disabled:text-gray-300 disabled:cursor-not-allowed focus:outline-none focus:border-gray-400"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 flex items-start gap-2.5 border border-sky-200 rounded-lg px-4 py-3 bg-sky-100">
        <i className="ri-information-line w-4 h-4 flex items-center justify-center text-gray-400 text-base mt-0.5 flex-shrink-0"></i>
        <p className="text-xs text-gray-500 leading-relaxed">
          2-й и последующие профили одной площадки — скидка 30%
        </p>
      </div>

      {showDiscount && (
        <div className="mt-4 inline-flex items-center gap-1 bg-gray-50 border border-gray-200 rounded-md px-3 py-2">
          <i className="ri-price-tag-3-line w-4 h-4 flex items-center justify-center text-gray-500 text-sm"></i>
          <span className="text-sm text-gray-700">
            Скидка за {enabledCount} площадки: −{discountPercent}%
          </span>
        </div>
      )}
    </section>
  );
}
